module.exports = __webpack_public_path__ + "img/BIA.b28ab37.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/BIA.png
// module id = 1148
// module chunks = 1